export const MAX_PROFILE_IMAGE_SIZE = 2 * 1024 * 1024;

export const ALLOWED_PROFILE_IMAGE_TYPES = ["image/jpeg", "image/png"];

export const PROFILE_IMAGE_ACCEPT =
  ".jpg,.jpeg,.png,image/jpeg,image/png";

export const PROFILE_IMAGE_SIZE_VALIDATION_MESSAGE =
  "Image size must be below 2 MB.";

export const PROFILE_IMAGE_TYPE_VALIDATION_MESSAGE =
  "Please select a JPG or PNG image.";

export const PROFILE_IMAGE_CROP_ASPECT = 1;

export const PROFILE_IMAGE_EXPORT_SIZE = 512;
